// Feature flags — set to true/false to enable/disable features.

// ARC-21: Allow players to edit their prompt/guess after submitting,
// while the phase timer is still running.
export const EDITABLE_SUBMISSIONS = false;

// ARC-43: Shared doodle pad in the lobby while players wait.
export const LOBBY_DOODLE_PAD = false;

// ARC-47: Sound effects (drawing scratches, timer ticks, phase transitions, etc.)
export const SOUND_EFFECTS = false;

// AI players (host can add bots in lobby). Disabled for now.
export const AI_PLAYERS = false;

// "Recent Masterpieces" gallery on the home screen. Hidden pre-launch: it shows
// unmoderated drawing images publicly to anonymous visitors. Re-enable once
// gallery content moderation (approve-list / review queue) is in place.
export const RECENT_MASTERPIECES = false;
